import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { RouteData } from '../context/integrations';

import ProtectedRoute from '../components/UI/ProtectedRoute';

import AdminRoute from '../components/UI/ProtectedRoute/AdminRoute';
import * as urls from './urls';

const Login = lazy(() => import('../container/LoginPage'));
const Insights = lazy(() => import('../container/Dashboard/Insights'));
const TestData = lazy(() => import('../container/Dashboard/TestData'));
const TestsFilterPage = lazy(() => import('../container/TestsFilterPage'));
const Analytics = lazy(() => import('../container/Dashboard/Analytics'));
const Certification = lazy(() => import('../container/Certification'));
const Admin = lazy(() => import('../container/Admin'));
const Tensile = lazy(() => import('../container/TensilePage/index'));

const PortableInsights = lazy(() =>
    import('../container/Portable/PortableArchive')
);

const Error404 = lazy(() => import('../container/Errors/404'));
const Error401 = lazy(() => import('../container/Errors/401'));
const PipTestPage = lazy(() => import('../container/PipTestPage'));

const AppRoutes = () => {
    const useRouteData = (children) => <RouteData>{children}</RouteData>;

    return (
        <Routes>
            <Route path={urls.LOGIN} element={<Login />} />
            <Route path="/" element={<ProtectedRoute />}>
                <Route
                    path={urls.INSIGHTS}
                    element={useRouteData(<Insights />)}
                />
                <Route
                    path={urls.ARCHIVE}
                    element={useRouteData(<TestData />)}
                />
                <Route
                    path={urls.ANALYTICS}
                    element={useRouteData(<Analytics />)}
                />
                <Route
                    path={urls.TENSILE}
                    element={useRouteData(<Tensile />)}
                />
                <Route
                    path={urls.CERTIFICATION}
                    element={useRouteData(<Certification />)}
                />
                <Route
                    path={urls.TESTS}
                    element={useRouteData(<TestsFilterPage />)}
                />
                <Route
                    path={urls.PIP_TEST}
                    element={useRouteData(<PipTestPage />)}
                />
                <Route path={urls.ADMIN} element={<AdminRoute />}>
                    <Route index element={useRouteData(<Admin />)} />
                </Route>
            </Route>
            <Route
                path={urls.PORTABLE_ARCHIVE}
                element={useRouteData(<PortableInsights />)}
            />

            <Route
                path={urls.ERROR_401}
                element={<Error401 />}
                statusCode={401}
            />

            <Route
                path={urls.ERROR_404}
                element={<Error404 />}
                statusCode={404}
            />

            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

export default AppRoutes;
